import { Button } from "@fluentui/react-components";
import { useMsal } from "@azure/msal-react";

import styles from "./LogoutButton.module.css";

export const LogoutButton = () => {
  const { instance } = useMsal();
  const handleLogoutPopup = () => {
    instance.logoutPopup();
  };
  return (
    <Button className={styles.logoutButton} onClick={handleLogoutPopup}>
      Logout
    </Button>
  );
};
